import { useEffect } from "react";
import api from "../lib/api";

/**
 * usePresenceHeartbeat — POSTs /presence/heartbeat every `intervalMs` (default
 * 60s). Silent failures are intentional: the backend already treats missing
 * heartbeats as "user probably left" and grace-period TTLs handle cleanup.
 *
 * Preserves original LiveRoom behavior exactly.
 */
export function usePresenceHeartbeat({ enabled, intervalMs = 60000 }) {
  useEffect(() => {
    if (!enabled) return undefined;
    const hb = setInterval(() => {
      api.post("/presence/heartbeat").catch(() => { /* offline / transient — TTL handles it */ });
    }, intervalMs);
    return () => clearInterval(hb);
  }, [enabled, intervalMs]);
}
